export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00349.7604aa52.png";